export enum ZmyleGiftcardOrderStatus {
  paymentAccepted = 'PAYMENT_ACCEPTED',
  produced = 'PRODUCED',
  activated = 'ACTIVATED',
  submitted = 'SUBMITTED',
  completed = 'COMPLETED',
}

export enum CookiesName {
  authToken = 'zlt',
  zmyleCookie = 'zmyle-cookie',
}

export enum AppHeaders {
  CSP = 'content-security-policy',
  NONCE = 'x-nonce',
  REQUESTED_URL = 'x-url',
  BROWSER_URL = 'x-browser-url',
  REMOTE_ADDR = 'x-remote-addr',
}

export enum ZmyleErrorId {
  INTERNAL_SERVER_ERROR = 'api:ex:internalError',
  TOO_MANY_REQUESTS = 'api:biz:tooManyRequests',
  NO_SUCH_GIFTCARD = 'api:biz:noSuchGiftcard',
  NO_SUCH_NETWORK = 'api:biz:noSuchNetwork',
  INVALID_QR_CODE = 'api:io:invalidQrCode',
  REQUIRES_AUTHENTICATION = 'api:biz:requiresAuthentication',
  MALFORMED_ID = 'api:io:malformedId',
  MALFORMED_URL = 'api:io:malformedUrl',
  INVALID_PINCODE = 'api:biz:invalidPincode',
  NO_SUCH_GIFTCARD_CONTEXT = 'api:biz:noSuchGiftcardCheckoutContext',
  IDEMPOTENT_REQUEST_BUSY = 'api:biz:idempotentRequestBusy',
  NO_SUCH_GIFTCARD_DEPOT = 'api:biz:noSuchGiftcardDepot',
  PDF_SERVICE_ERROR = 'api:biz:pdfServiceError',
}

export const zmyleGiftcardUrlRegExp =
  /(https:\/\/.*)\/g\/([a-z0-9]{12,})(\/.*)?\?r?t=([a-z0-9]{15,})$/;
